$(function() {
    toggleNav();

    $('.btn-has-bg').each(function(){
        $(this).on('mouseenter', function(e) {
            var parentOffset = $(this).offset(),
                relX = e.pageX - parentOffset.left,
                relY = e.pageY - parentOffset.top;
            $(this).find('.bg').css({top:relY, left:relX})
        })
        .on('mouseout', function(e) {
            var parentOffset = $(this).offset(),
                relX = e.pageX - parentOffset.left,
                relY = e.pageY - parentOffset.top;
            $(this).find('.bg').css({top:relY, left:relX})
        });
    });
});
/*==================================================
gnav
==================================================*/
function toggleNav(){
    const headerWrap = $('.tabin-lp-header');
    const navBtn = headerWrap.find('.btn-nav');
    const navLink = headerWrap.find('.nav-link');
    let scrollPosition;

    function openNav() {
        scrollPosition = $(window).scrollTop();
        headerWrap.addClass('is-open');
    }
    function closeNav() {
        headerWrap.removeClass('is-open');
    }

    if(headerWrap.length > 0){
        navBtn.add(navLink).add($('.btn-tabin')).on('click', function(){
            if(headerWrap.hasClass('is-open')){
                closeNav();
            } else {
                openNav();
            }
        });

        // nav領域以外のところをクリックすると閉じる
        $('.tabin-lp-wrap').on('click', function(e){
            if ($(e.target).is(navBtn) || $(e.target).closest(navBtn).length) return;
            if (!$(e.target).closest('.tabin-lp-header').length && headerWrap.hasClass('is-open')) {
                closeNav();
            }
        });

        // scroll時の変化
        toggleHeaderScroll(headerWrap);
        $(window).on('scroll resize', function(){
            toggleHeaderScroll(headerWrap);
        });
    }

    // export
    toggleNav.close = closeNav;
    toggleNav.open = openNav;
};
function toggleHeaderScroll(header){
    const $header = $(header || '.l-header');
    if($header.length == 0 && $header.hasClass('is-scroll')) return;

    let wid = window.innerWidth;
    // let tgHeight = $header.height();
    let tgHeight = $('.tabin-lp-main .fixed-contents').height() - 55;

    if(wid < 1200 && $(window).scrollTop() >= tgHeight){
        $header.addClass('is-scroll');
    } else {
        $header.removeClass('is-scroll');
    }
};